import { createRoot } from "react-dom/client";
import "./green.css";
import { AppRoutes } from "./routes/index.tsx";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./context/theme-context.tsx";
import { Toaster } from "sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" duration={4000} theme="system" />
      </BrowserRouter>
    </QueryClientProvider>
  </ThemeProvider>,
);
